/* Content Box */
export type Item = { 
  field: string, 
  value?: string | React.ReactNode, 
  state?: string | React.ReactNode, 
  extra?: Item 
}

interface IContentBoxProps {
  label: string;
  content: Item[]
}

export const ContentBox: React.FC<IContentBoxProps> = (props: IContentBoxProps) => {
  const { label, content } = props;

  const loanDocsClosing = [
    'Pre-approval letter',
    'Closing documents',
    'Term sheet',
    'Appraisal'
  ];

  const termSheetContent = content.filter(item => item.field === 'Term sheet');
  const appraisalContent = content.filter(item => !loanDocsClosing.includes(item.field))
  const closingContent = content.filter(item => loanDocsClosing.includes(item.field))
  const closingFiles = content.filter(item => item.field === 'Closing documents');

  return (
    <div className='content-box'>
      <div className='label'>
        {label}
      </div>
     
      <br />
      {appraisalContent.length > 0 && (
        <div className='content'>
          {appraisalContent.map(({ field, state, value, extra }, index) => (
            <div key={index} className='item'>
              <div className='item-row'>
                <div className={`field`}>{field}</div>
                <div className={`field`}>{state}</div>
                <div className='value'>{value}</div>
              </div>
              {extra && (
                <div className='item-row extra'>
                  <div className='field'>{extra.field}</div>
                  <div className='value'>{extra.value}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <br />
      {closingContent.length > 0 && (
        <div className='content'>
          {closingContent.filter((item: any) => item.field !== 'Closing documents').map(({ field, state, value, extra }, index) => (
            <div key={index} className='item'>
              <div className='item-row'>
                <div className={`field`}>{field}</div>
                <div className={`field`}>{state}</div>
                <div className='value'>{value}</div>
              </div>
              {extra && (
                <div className='item-row extra'>
                  <div className='field'>{extra.field}</div>
                  <div className='value'>{extra.value}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <br />
      {closingFiles.length > 0 && (
        <div className='content'>
          {closingFiles.map(({ field, state, value, extra }, index) => (
            <div key={index} className='item'>
              <div className='item-row'>
                {index === 0 && <div className={`field`}>{field}</div>}
                <div className={`field`}>{state}</div>
                <div className='value'>{value}</div>
              </div>
              {extra && (
                <div className='item-row extra'>
                  <div className='field'>{extra.field}</div>
                  <div className='value'>{extra.value}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};